export default __webpack_public_path__ + "static/sub-one-xl-f2460f4410c3ae4aee663f7cf6793857.svg";